import { getStripeSubscription } from 'helpers/backend_helper';
import { getPreferredActiveLicense } from 'helpers/licenseSubscriptionModal';
import { useLicenseActionModals } from './useLicenseActionModals';
import { toast } from 'react-toastify';

/**
 * "Purchase license" for a free trial: loads the business's active (trial) license and
 * opens the license modal in purchase mode. Render `purchaseLicenseModals` once in the
 * caller. Shared by the quick links and the reports page.
 */
export const usePurchaseLicense = ({ showModal, onPurchased }: { showModal: any; onPurchased?: () => void }) => {
    const { openLicenseChangePlan, licenseActionModals, licenseModalOpen } = useLicenseActionModals({
        refreshList: () => onPurchased?.(),
        showModal,
    });

    const openPurchaseLicense = async () => {
        try {
            const subscription = await getStripeSubscription();
            const licenses = [
                ...(Array.isArray(subscription?.licenses) ? subscription.licenses : []),
                subscription?.license,
            ].filter(Boolean);
            const license = getPreferredActiveLicense(licenses) || licenses[0];
            if (!license) throw new Error('No license was found for this business.');
            openLicenseChangePlan(license, { hydrated: true });
        } catch (error: any) {
            toast.error(typeof error === 'string' ? error : error?.message || 'Failed to load license purchase options. Please try again.');
        }
    };

    return { openPurchaseLicense, purchaseLicenseModals: licenseActionModals, purchaseLicenseOpen: licenseModalOpen };
};
